<template>
  <div
    class="location-image"
    :class="[themeClass, {'no-image': !location}, {'image-sticked': isImageSticked}]"
  >
    <div class="location-image__wrapper">
      <transition name="fade">
        <CloudinaryImage
          v-if="location"
          :image-source="locationImageSrc"
          :image-alt="locationImageAlt"
        />
      </transition>
    </div>
  </div>
</template>
<script>
import CloudinaryImage from '~/components/cloudinary-image'
import get from '~/helpers/get'

export default {
  name: 'LocationImage',

  components: {
    CloudinaryImage
  },

  props: {
    location: {
      type: Object,
      default: () => null
    },
    themeClass: {
      type: String,
      default: () => ''
    },
    isImageSticked: {
      type: Boolean,
      default: () => false
    }
  },

  computed: {
    locationImageSrc () {
      return get(this.location, 'image.value.src', '')
    },
    locationImageAlt () {
      return get(this.location, 'image.value.alt', '')
    }
  }
}
</script>
<style lang="scss" scoped>
  // the values are set in accordance with the visual design
  $mobile-image-width: 75vw;
  $mobile-image-wrapper-height: 52vw;
  $mobile-image-wrapper-max-height: 50vh;
  $desktop-image-wrapper-width: 375px;
  $desktop-image-wrapper-height: 260px;
  $tablet-image-sticked-top-position: 150px;
  $desktop-image-sticked-top-position: 300px;
  $container-with-no-image-z-index: -1;

  .location-image {
    width: 100%;
    padding: $space-090 0;
    background-image: linear-gradient($color-white 0%, $color-white 85%, transparent 95%);
    text-align: right;

    @include tablet {
      width: auto;
      position: absolute;
      top: $tablet-image-sticked-top-position;
      left: auto;
      @include inset-space(0);
    }
    @include desktop {
      top: $desktop-image-sticked-top-position;
    }

    &__wrapper {
      overflow: hidden;
      display: inline-block;
      height: $mobile-image-wrapper-height;
      max-height: $mobile-image-wrapper-max-height;

      @include tablet {
        width: $desktop-image-wrapper-width;
        height: $desktop-image-wrapper-height;
      }
    }

    img {
      display: block;
      height: 100%;
      max-width: $mobile-image-width;
      object-fit: contain;
      object-position: right top;

      @include tablet {
        width: 100%;
      }
    }

    &.image-sticked {
      position: fixed;
      z-index: 10;
      top: 0;

      @include tablet {
        left: auto;
        top: $tablet-image-sticked-top-position;
      }
      @include desktop {
        left: auto;
        top: $desktop-image-sticked-top-position;
      }
    }

    &.theme-dark {
      background-image: linear-gradient($color-black 0%, $color-black 85%, transparent 95%);
    }

    &.no-image {
      background-image: none;
      background-color: transparent;
      z-index: $container-with-no-image-z-index;
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .2s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
</style>
